/**
 * 平台混入 - 提供平台相关的通用功能
 */
import { PLATFORM_BATCH_CONFIG } from '../config/platformConfig.js'

export default {
  props: {
    // 平台类型
    platform: {
      type: String,
      required: true,
      validator(value) {
        return Object.keys(PLATFORM_BATCH_CONFIG).includes(value)
      }
    }
  },
  
  computed: {
    // 当前平台配置
    platformConfig() {
      return PLATFORM_BATCH_CONFIG[this.platform] || {}
    },
    
    // 平台名称
    platformName() {
      return this.platformConfig.name || '未知平台'
    },
    
    // 平台API配置
    platformApi() {
      return this.platformConfig.api || {}
    },
    
    // 平台特定配置
    platformSpecificConfig() {
      return this.platformConfig.config || {}
    }
  },
  
  methods: {
    // 检查平台是否支持某个功能
    isPlatformFeatureSupported(feature) {
      return this.platformSpecificConfig[feature] || false
    },
    
    // 获取平台特定的API地址
    getPlatformApiUrl(apiName) {
      return this.platformApi[apiName] || ''
    },
    
    // 获取平台特定配置值
    getPlatformConfigValue(key, defaultValue = null) {
      return this.platformSpecificConfig[key] || defaultValue
    }
  }
}